// Copyright (c) 2016 Deere & Company

import React, {Component, PropTypes} from 'react';
import {
    getDecimalSeparator,
    getThousandSeparator
} from '../../services/formatted-number-input';
import NumberFormat from 'react-number-format';
import User from '@deere/cps-it.warranty-model-factory/lib/user';

function notNull(value) {

    return value === null ? '' : value;

}

class FormattedNumberInput extends Component {

    state = {
        value: notNull(this.props.value)
    };

    componentWillReceiveProps = nextProps => {

        this.setState({
            value: notNull(nextProps.value)
        });

    };

    getRawNumber = value => {

        const rawString = value.replace(/[^0-9]/g, '');

        return rawString ? Number(rawString) / Math.pow(10, this.props.decimalPrecision) : null;

    };

    handleBlur = event => {

        this.props.onBlur(this.getRawNumber(event.target.value));

    };

    handlePaste = event => {

        const clipboardData = event.clipboardData || window.clipboardData;
        const pastedData = clipboardData.getData('Text');
        const potentialError = (/^(?=.*[a-zA-Z])(?=.*[0-9])/).test(pastedData);

        if (potentialError) {

            event.preventDefault();

        }

    };

    handleChange = (event, value) => {

        const rawNumber = this.getRawNumber(value);

        if (this.props.isValidInput(rawNumber)) {

            this.props.onValueChange(rawNumber);

        } else {

            this.setState({
                value: this.props.value
            });

        }

    };

    render() {

        return (

            <NumberFormat
                {...this.props}
                allowNegative={this.props.allowNegative}
                className={this.props.className}
                decimalPrecision={this.props.decimalPrecision}
                decimalSeparator={getDecimalSeparator(this.context.user.settings.general.decimalFormat.key)}
                disabled={this.props.disabled}
                onBlur={this.handleBlur}
                onChange={this.handleChange}
                onPaste={this.handlePaste}
                placeholder={this.props.placeholder}
                thousandSeparator={getThousandSeparator(this.context.user.settings.general.decimalFormat.key)}
                value={this.state.value}
            />

        );

    }

}

FormattedNumberInput.displayName = 'FormattedNumberInput';
FormattedNumberInput.propTypes = {
    allowNegative: PropTypes.bool.isRequired,
    className: PropTypes.string,
    decimalPrecision: PropTypes.number,
    disabled: PropTypes.bool,
    isValidInput: PropTypes.func,
    onBlur: PropTypes.func,
    onValueChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.number
};
FormattedNumberInput.defaultProps = {
    className: 'formatted-number-input',
    decimalPrecision: 0,
    disabled: false,
    isValidInput: () => true,
    onBlur: () => ({}),
    placeholder: ''
};
FormattedNumberInput.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default FormattedNumberInput;



// WEBPACK FOOTER //
// ./src/shared/components/formatted-number-input/index.js